import { useMutation } from '@apollo/client';
import { EUserEditorAccessLevel, EUserRole } from '__generated__/globalTypes';
import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { SelectValue } from 'elements/minute/sidebar/sidebarComponents/atomic/SelectValue';
import {
    ChangeUserSubscriptionByAdmin,
    ChangeUserSubscriptionByAdminVariables
} from 'libs/graphql/mutation/access/__generated__/ChangeUserSubscriptionByAdmin';
import { CHANGE_USER_SUBSCRIPTION_BY_ADMIN_MUTATION } from 'libs/graphql/mutation/access/accessMutation';
import { useContext, useState } from 'react';
import { GlobalContext } from 'session/state/context';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    userId: string;
    accessLevel: EUserEditorAccessLevel;
}

const options = [
    {
        value: 'free',
        label: 'FREE',
        enum: EUserEditorAccessLevel.FREE
    },
    {
        value: 'full',
        label: 'FULL',
        enum: EUserEditorAccessLevel.FULL
    }
];

export const UserRoleField = (props: Props): JSX.Element => {
    const [isEditting, setIsEditting] = useState(false);
    const [selectedValue, setSelectedValue] = useState(props.accessLevel);
    const [savedValue, setSavedValue] = useState(props.accessLevel);

    const globalContext = useContext(GlobalContext);
    const currentUser = globalContext.state.loggedUser;

    const [updateSubscription] = useMutation<
        ChangeUserSubscriptionByAdmin,
        ChangeUserSubscriptionByAdminVariables
    >(CHANGE_USER_SUBSCRIPTION_BY_ADMIN_MUTATION);

    return (
        <S_UserRoleField className={props.className}>
            {isEditting ? (
                <>
                    <SelectValue
                        options={options}
                        selectedOption={options.find((e) => e.enum === selectedValue)}
                        onChange={(newValue) => {
                            const newEnum = options.find((e) => e.value === newValue.value);
                            setSelectedValue(newEnum.enum);
                        }}
                    />
                    <S_EditIcon
                        icon={{
                            iconSet: 'far',
                            iconName: 'check'
                        }}
                        onClick={() => {
                            updateSubscription({
                                variables: {
                                    userId: props.userId,
                                    input: {
                                        userAccessLevel: selectedValue
                                    }
                                },
                                onCompleted: (data) => {
                                    const newEnum =
                                        data.changeUserSubscriptionByAdmin.userAccessLevel;
                                    setSavedValue(newEnum);
                                    setIsEditting(false);
                                }
                            });
                        }}
                    />
                </>
            ) : (
                <>
                    {savedValue}
                    {currentUser.role === EUserRole.ADMIN && (
                        <S_EditIcon
                            icon={{
                                iconSet: 'far',
                                iconName: 'edit'
                            }}
                            onClick={() => {
                                setIsEditting(true);
                            }}
                        />
                    )}
                </>
            )}
        </S_UserRoleField>
    );
};

const S_UserRoleField = styled.div`
    display: flex;
    align-items: center;
`;

const S_EditIcon = styled(ActionButton)`
    margin-left: 8px;
`;
